<template>

  <div>
    <router-view/>
  </div>

</template>

<script>
  export default {
    name: 'AdminFinanceiro',
  }
</script>

<style scoped>
</style>
